import React, { useContext } from "react";
import AuthenticationContext from "../Authentication/AuthenticationContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Loader from "../utils/Loader";

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();

  const { isLogged, isChecked } = useContext(AuthenticationContext);

  if (!isChecked) {
    return <Loader />;
  }

  if (isLogged && location.pathname === "/login") {
    return <Navigate to={"/"} />;
  }
  if (!isLogged && location.pathname !== "/login") {
    return <Navigate to="/login" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
